<template>
    <div class="form-group" v-bind:class="{'dark': this.getDesign() == 'black', 'white' : this.getDesign() == 'white'}">
        <label for="">{{ $t(this.field.name) }}  <span v-if="field.isRequired">*</span></label>
        <textarea :required="field.isRequired" v-model="value" name="" id="" cols="30" rows="10" @change="changeInput"></textarea>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';

    export default {
        name: "textarea-normal",
        props: ["field","experience","room","start"],
        data() {
            return {
                value: '',
            }
        },
        computed: {
            ...mapGetters(['getDesign','getCheckout','getFieldItems'])
        },
        created() {

            if(this.field.value) {
                this.value = this.field.value;
            }

            let fieldTemp = this.getFieldItems({id_experience: this.experience, id_calendario : this.room, title: this.field.name});
            if(fieldTemp) {
                this.value = fieldTemp.value;
            }

            this.changeInput();
        },
        methods: {
            ...mapMutations(['updateItemField']),
            changeInput: function () {

                const newField =  {
                    id: this.$uuid.v4(this.field.id),
                    name: this.field.name,
                    title: this.field.name,
                    value: this.value,
                    amount: 0,
                    total: 0,
                    id_custom_fields_options: this.field.id_custom_fields_options
                };
                
                this.updateItemField({id_experience: this.experience, id_calendario : this.room, newField: newField, start: this.start});

                if(this.getCheckout().id) {
                    this.$emit('change-field');
                }
            }
        }
    }
</script>

<style scoped>

</style>
